import { useRuntimeAuth } from "./useRuntimeAuth"

/**
 * Hooks that retrive current user logged in
 */
export const useRuntimeUser = () => {
    const auth = useRuntimeAuth()
    return auth?.user
}
